import PageMetaData from '@v4/utils/data/PageMetaData'
import { MEDIA_POSITION } from './Question.const'

export const getMediaSortDirection = (position, direction) => {
	switch (position) {
		case MEDIA_POSITION.LEFT_COVER:
		case MEDIA_POSITION.LEFT_CONTAINED:
		case MEDIA_POSITION.TOP_COVER: {
			return direction === 'rtl' ? PageMetaData.SORT_DIRECTION.ASC : PageMetaData.SORT_DIRECTION.DESC
		}

		case MEDIA_POSITION.RIGHT_COVER:
		case MEDIA_POSITION.RIGHT_CONTAINED: {
			return direction === 'rtl' ? PageMetaData.SORT_DIRECTION.DESC : PageMetaData.SORT_DIRECTION.ASC
		}

		default:
			return PageMetaData.SORT_DIRECTION.ASC
	}
}

export const isSingleGrid = position =>
	_.includes([MEDIA_POSITION.BACKGROUND, MEDIA_POSITION.ABOVE_QUESTION, MEDIA_POSITION.BELOW_QUESTION], position)

export const isDoubleGrid = position =>
	_.includes(
		[
			MEDIA_POSITION.LEFT_CONTAINED,
			MEDIA_POSITION.RIGHT_CONTAINED,
			MEDIA_POSITION.LEFT_COVER,
			MEDIA_POSITION.RIGHT_COVER,
		],
		position,
	)
export const isPositionBackground = position => MEDIA_POSITION.BACKGROUND === position

export const isPositionCover = position => _.includes([MEDIA_POSITION.LEFT_COVER, MEDIA_POSITION.RIGHT_COVER], position)

export const isPositionContained = position =>
	_.includes([MEDIA_POSITION.LEFT_CONTAINED, MEDIA_POSITION.RIGHT_CONTAINED], position)
